import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Notification } from '@models/release-notes/notification';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfileNotificationService {

  constructor(private http: HttpClient) { }

  getNotifications(): Observable<Notification[]> {
    return this.http.get<Notification[]>('/web-app-svc/notifications/dashboard');
  }
}
